export const SETUSERNAME = 'SETUSERNAME';
export const SETMARKDATA = 'SETMARKDATA';
export const SETSUCCESSDATA = 'SETSUCCESSDATA';
export const SETFULLEXPAND = 'SETFULLEXPAND';
export const SETLOCALPAGE = 'SETLOCALPAGE';
export const SETSTARTCHECK = 'SETSTARTCHECK';
export const OPENTOOLS = 'OPENTOOLS';
export const SETDEGRESS = 'SETDEGRESS';
export const MARKSELECTED = 'MARKSELECTED';
export const CURRENTIMAGE = 'CURRENTIMAGE';
export const SETSWITVHAUTO = 'SETSWITVHAUTO';
export const EDITTEMPLATE = 'EDITTEMPLATE';
export const STANDARDTESTON = 'STANDARDTESTON';
export const STANDARDUPDATETOTAL = 'STANDARDUPDATETOTAL';
export const SETNAVHIDDEN = 'SETNAVHIDDEN';
export const SETROLE = 'SETROLE';
export const USERTYPE = 'USERTYPE';
export const SETTESTTEMPLATE = 'SETTESTTEMPLATE';
export const CREATETEMPLATE = 'CREATETEMPLATE';
export const CREATETOOLS = 'CREATETOOLS';
export const SETCERTIFICATE = 'SETCERTIFICATE';
export const SETADDROW = 'SETADDROW';
export const SETMINUSROW = 'SETMINUSROW';
export const SETTABLEINPUT = 'SETTABLEINPUT';
export const SETTABLEFOCUS = 'SETTABLEFOCUS';
export const SETTABLEBLUR = 'SETTABLEBLUR';
export const SETINDENTIFYPAGE = 'SETINDENTIFYPAGE';
export const SETSUCCESSALLDATA = 'SETSUCCESSALLDATA';
export const SETTABSWITCH = 'SETTABSWITCH';
export const SETIMAGEITEM = 'SETIMAGEITEM';
export const SETEDITTYPE = 'SETEDITTYPE';
export const SETRECHECK = 'SETRECHECK';
export const DRAWOPEN = 'DRAWOPEN';
export const OCRRESULT = 'OCRRESULT';
export const NEWORIGIBDATA = 'NEWORIGIBDATA';
export const CHANGENEWORIGIBDATA = 'CHANGENEWORIGIBDATA';
export const SETTABOCRNAME = 'SETTABOCRNAME';
export const SETEDITPAGETAB = 'SETEDITPAGETAB';
export const SETGROUPLIKST = 'SETGROUPLIKST';
export const MARKCREATE = 'MARKCREATE';
export const EDITNODE = 'EDITNODE';
export const SETDOCTYPENUM = 'SETDOCTYPENUM';
export const SETMOVESHOW = 'SETMOVESHOW';
export const SETSIGGINGARRLIST = 'SETSIGGINGARRLIST';
export const SETRESITEN = 'SETRESITEN';
export const SETITEMERROR = 'SETITEMERROR';
export const SETERRORNEWPAGE = 'SETERRORNEWPAGE'
export const DEMOFLAG = 'DEMOFLAG'
